<div class="header-container print-visible">
  <div class="search-container print-visible">
    <img *ngIf="header" class="img-fluid img-center-sm print-visible" [src]="header?.image" alt="">
  </div>
  <div class="actions" *ngIf="isAuthenticated && showActions">
    <p-menu #menuExternalLinks [popup]="true" [model]="externalLinksMenuItems"></p-menu>
    <div class="action-item" *ngIf="displayExternalLinks">
      <div class="action-item" (click)="menuExternalLinks.toggle($event)" *ngIf="conference?.externalLinks && conference.externalLinks.length > 0">
        {{conference.externalLinksMenuLabel}}
        <div [innerHTML]="colorService.svgList.external_link_alt_solid_svg.htmlText" class="external-link-alt-solid"></div>
      </div>
    </div>
    <div class="action-item" *ngIf="userInfo?.name" tabindex="0" role="button" (click)="navigate('/profile')">
      {{ userInfo.name }}
      <div [innerHTML]="colorService.svgList.user2_svg.htmlText" class="user2"></div>
    </div>
    <div class="action-item" (click)="showDialog()" tabindex="0" role="button">
      Sair
      <div [innerHTML]="colorService.svgList.close2_svg.htmlText" class="close2"></div>
    </div>
  </div>
</div>

<p-dialog [(visible)]="display">
  <div class="dialog-title">
    <i class="far fa-times-circle"></i>
    <span class="title-text">Já está de saída?</span>
  </div>
  <div class="dialog-content">
    <span>Antes de ir por favor responda à nossa</span>
    <p-button icon="fas fa-clipboard-list" label="Pesquisa ({{estimatedTimeResearch}})" (onClick)="researchRedirect()">
    </p-button>
    <div class="options">
      <div class="option" (click)="wannaAnswerLater({answer: true})">
        <span>Responder depois</span>
      </div>
      <div class="option" (click)="wannaAnswerLater({answer: false})">
        <span>Não, obrigado</span>
      </div>
    </div>
  </div>
</p-dialog>
